import {ReactNode} from 'react'
import {CheckIcon} from '@/components/ui/icon/Icon'
import {
    StyledCardCheckbox,
    StyledCardTexts,
    StyledCheckSquare,
    StyledIconTile
} from '@/features/mailer/components/mailer-card-checkbox/style'

interface MailerCardCheckboxProps {
    checked: boolean
    onToggle: () => void
    icon: ReactNode
    title: string
    subtitle: string
}

export const MailerCardCheckbox = ({checked, onToggle, icon, title, subtitle}: MailerCardCheckboxProps) => (
    <StyledCardCheckbox type="button" role="checkbox" aria-checked={checked} $checked={checked} onClick={onToggle}>
        <StyledCheckSquare $checked={checked}>{checked && <CheckIcon />}</StyledCheckSquare>
        <StyledIconTile $checked={checked}>{icon}</StyledIconTile>
        <StyledCardTexts>
            <strong>{title}</strong>
            <small>{subtitle}</small>
        </StyledCardTexts>
    </StyledCardCheckbox>
)

MailerCardCheckbox.displayName = 'MailerCardCheckbox'
